import { useState, useEffect } from 'react';



import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import MonthlyFeeCard from './components/MonthlyFeeCard';
import FeeRateConfigModal from './components/FeeRateConfigModal';
import FeeDetailsModal from './components/FeeDetailsModal';
import BulkInvoiceModal from './components/BulkInvoiceModal';
import FilterPanel from './components/FilterPanel';
import SummaryPanel from './components/SummaryPanel';
import TopNavbar from '../../components/ui/TopNavbar';

const FeeRegister = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isRateConfigOpen, setIsRateConfigOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isBulkInvoiceOpen, setIsBulkInvoiceOpen] = useState(false);
  const [selectedFeeData, setSelectedFeeData] = useState(null);
  const [userRole, setUserRole] = useState('Finance');
  const [isCalculating, setIsCalculating] = useState(false);
  const [showRateConfigModal, setShowRateConfigModal] = useState(false);
  const [filters, setFilters] = useState({
    period: 'monthly',
    year: '2024',
    quarter: 'Q4',
    status: 'all',
  });

  const currentRates = {
    current: '$3.50',
    currency: 'USD',
    effectiveDate: '01 Oct 2024',
  };

  const feeRecords = [
    {
      id: 1,
      month: 'November 2024',
      invoiceNumber: 'INV-2024-11-001',
      status: 'paid',
      totalTonnage: 125000.0,
      feeRate: 3.5,
      grossFee: 437500.0,
      advancePayment: 144375.0,
      reimbursableCosts: 45000.0,
      netBalance: 248125.0,
      shipmentsCount: 8,
      paymentDate: '05 Dec 2024',
      notes: 'All shipments completed successfully. Payment received on time.',
      shipments: [
        {
          vessel: 'MV Pacific Glory',
          supplier: 'Whitehaven Coal',
          buyer: 'Adani Power',
          tonnage: 35000.0,
          feeAmount: 122500.0,
        },
        {
          vessel: 'MV Ocean Trader',
          supplier: 'Glencore Coal',
          buyer: 'Tata Power',
          tonnage: 28000.0,
          feeAmount: 98000.0,
        },
        {
          vessel: 'MV Sea Pioneer',
          supplier: 'BHP Coal',
          buyer: 'NTPC Limited',
          tonnage: 32000.0,
          feeAmount: 112000.0,
        },
        {
          vessel: 'MV Global Express',
          supplier: 'Peabody Energy',
          buyer: 'JSW Energy',
          tonnage: 30000.0,
          feeAmount: 105000.0,
        },
      ],
      costBreakdown: [
        { category: 'Inspection Costs', amount: 18000.0 },
        { category: 'Lab Testing', amount: 12000.0 },
        { category: 'Customs Broker Fees', amount: 8000.0 },
        { category: 'Courier Services', amount: 4000.0 },
        { category: 'Legal Fees', amount: 3000.0 },
      ],
    },
    {
      id: 2,
      month: 'October 2024',
      invoiceNumber: 'INV-2024-10-001',
      status: 'paid',
      totalTonnage: 142000.0,
      feeRate: 3.5,
      grossFee: 497000.0,
      advancePayment: 163910.0,
      reimbursableCosts: 52000.0,
      netBalance: 281090.0,
      shipmentsCount: 9,
      paymentDate: '08 Nov 2024',
      notes:
        'Record month with highest tonnage. Two additional shipments completed.',
      shipments: [
        {
          vessel: 'MV Atlantic Star',
          supplier: 'Whitehaven Coal',
          buyer: 'Reliance Power',
          tonnage: 38000.0,
          feeAmount: 133000.0,
        },
        {
          vessel: 'MV Indian Ocean',
          supplier: 'Glencore Coal',
          buyer: 'Adani Power',
          tonnage: 35000.0,
          feeAmount: 122500.0,
        },
        {
          vessel: 'MV Coal Express',
          supplier: 'BHP Coal',
          buyer: 'Tata Power',
          tonnage: 33000.0,
          feeAmount: 115500.0,
        },
        {
          vessel: 'MV Pacific Venture',
          supplier: 'Peabody Energy',
          buyer: 'NTPC Limited',
          tonnage: 36000.0,
          feeAmount: 126000.0,
        },
      ],
      costBreakdown: [
        { category: 'Inspection Costs', amount: 22000.0 },
        { category: 'Lab Testing', amount: 15000.0 },
        { category: 'Customs Broker Fees', amount: 9000.0 },
        { category: 'Travel Expenses', amount: 4000.0 },
        { category: 'Legal Fees', amount: 2000.0 },
      ],
    },
    {
      id: 3,
      month: 'September 2024',
      invoiceNumber: 'INV-2024-09-001',
      status: 'pending',
      totalTonnage: 118000.0,
      feeRate: 3.5,
      grossFee: 413000.0,
      advancePayment: 136290.0,
      reimbursableCosts: 41000.0,
      netBalance: 235710.0,
      shipmentsCount: 7,
      paymentDate: null,
      notes: 'Invoice sent on 05 Oct. Payment expected by 20 Oct.',
      shipments: [
        {
          vessel: 'MV Southern Cross',
          supplier: 'Whitehaven Coal',
          buyer: 'JSW Energy',
          tonnage: 32000.0,
          feeAmount: 112000.0,
        },
        {
          vessel: 'MV Eastern Star',
          supplier: 'Glencore Coal',
          buyer: 'Adani Power',
          tonnage: 30000.0,
          feeAmount: 105000.0,
        },
        {
          vessel: 'MV Coal Carrier',
          supplier: 'BHP Coal',
          buyer: 'Tata Power',
          tonnage: 28000.0,
          feeAmount: 98000.0,
        },
        {
          vessel: 'MV Pacific Dream',
          supplier: 'Peabody Energy',
          buyer: 'NTPC Limited',
          tonnage: 28000.0,
          feeAmount: 98000.0,
        },
      ],
      costBreakdown: [
        { category: 'Inspection Costs', amount: 16000.0 },
        { category: 'Lab Testing', amount: 11000.0 },
        { category: 'Customs Broker Fees', amount: 8000.0 },
        { category: 'Courier Services', amount: 4000.0 },
        { category: 'Legal Fees', amount: 2000.0 },
      ],
    },
    {
      id: 4,
      month: 'August 2024',
      invoiceNumber: 'INV-2024-08-001',
      status: 'overdue',
      totalTonnage: 95000.0,
      feeRate: 3.5,
      grossFee: 332500.0,
      advancePayment: 109725.0,
      reimbursableCosts: 38000.0,
      netBalance: 184775.0,
      shipmentsCount: 6,
      paymentDate: null,
      notes:
        'Payment overdue by 15 days. Follow-up required with RNR finance team.',
      shipments: [
        {
          vessel: 'MV Western Pride',
          supplier: 'Whitehaven Coal',
          buyer: 'Reliance Power',
          tonnage: 28000.0,
          feeAmount: 98000.0,
        },
        {
          vessel: 'MV Northern Light',
          supplier: 'Glencore Coal',
          buyer: 'Adani Power',
          tonnage: 25000.0,
          feeAmount: 87500.0,
        },
        {
          vessel: 'MV Coal Master',
          supplier: 'BHP Coal',
          buyer: 'Tata Power',
          tonnage: 22000.0,
          feeAmount: 77000.0,
        },
        {
          vessel: 'MV Pacific Hope',
          supplier: 'Peabody Energy',
          buyer: 'JSW Energy',
          tonnage: 20000.0,
          feeAmount: 70000.0,
        },
      ],
      costBreakdown: [
        { category: 'Inspection Costs', amount: 15000.0 },
        { category: 'Lab Testing', amount: 10000.0 },
        { category: 'Customs Broker Fees', amount: 7000.0 },
        { category: 'Travel Expenses', amount: 4000.0 },
        { category: 'Legal Fees', amount: 2000.0 },
      ],
    },
    {
      id: 5,
      month: 'July 2024',
      invoiceNumber: 'INV-2024-07-001',
      status: 'draft',
      totalTonnage: 132000.0,
      feeRate: 3.5,
      grossFee: 462000.0,
      advancePayment: 152460.0,
      reimbursableCosts: 48000.0,
      netBalance: 261540.0,
      shipmentsCount: 8,
      paymentDate: null,
      notes:
        'Draft invoice pending final review. Awaiting confirmation on reimbursable costs.',
      shipments: [
        {
          vessel: 'MV Global Trader',
          supplier: 'Whitehaven Coal',
          buyer: 'NTPC Limited',
          tonnage: 36000.0,
          feeAmount: 126000.0,
        },
        {
          vessel: 'MV Ocean Master',
          supplier: 'Glencore Coal',
          buyer: 'Adani Power',
          tonnage: 34000.0,
          feeAmount: 119000.0,
        },
        {
          vessel: 'MV Sea Champion',
          supplier: 'BHP Coal',
          buyer: 'Tata Power',
          tonnage: 32000.0,
          feeAmount: 112000.0,
        },
        {
          vessel: 'MV Pacific Leader',
          supplier: 'Peabody Energy',
          buyer: 'JSW Energy',
          tonnage: 30000.0,
          feeAmount: 105000.0,
        },
      ],
      costBreakdown: [
        { category: 'Inspection Costs', amount: 20000.0 },
        { category: 'Lab Testing', amount: 13000.0 },
        { category: 'Customs Broker Fees', amount: 9000.0 },
        { category: 'Courier Services', amount: 4000.0 },
        { category: 'Legal Fees', amount: 2000.0 },
      ],
    },
  ];

  const summaryData = {
    totalRevenue: 2142000.0,
    totalTonnage: 612000.0,
    avgFeeRate: 3.5,
    grossFees: 2142000.0,
    advancePaid: 706860.0,
    reimbursements: 224000.0,
    netBalance: 1211140.0,
    topSuppliers: [
      { name: 'Whitehaven Coal', tonnage: 169000.0, percentage: 27.6 },
      { name: 'Glencore Coal', tonnage: 152000.0, percentage: 24.8 },
      { name: 'BHP Coal', tonnage: 147000.0, percentage: 24.0 },
      { name: 'Peabody Energy', tonnage: 144000.0, percentage: 23.5 },
    ],
  };

  useEffect(() => {
    document.title = 'Fee Register - HCC';
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    console.log('Filters updated:', newFilters);
  };

  const handleRateConfigSave = (rateData) => {
    console.log('New rate configuration:', rateData);
    setIsRateConfigOpen(false);
  };

  const handleEditFee = (feeData) => {
    console.log('Edit fee:', feeData);
  };

  const handleViewDetails = (feeData) => {
    setSelectedFeeData(feeData);
    setIsDetailsModalOpen(true);
  };

  const handleExport = () => {
    console.log('Export fee records');
  };

  const handleBulkInvoice = () => {
    setIsBulkInvoiceOpen(true);
  };

  const handleCalculateFees = () => {
    setIsCalculating(true);
    setTimeout(() => {
      setIsCalculating(false);
      alert('✅ Fee calculation completed!');
    }, 1500);
  };

  const handleGenerateInvoice = (month) => {
    console.log('Generating invoice for:', month);
    alert(`✅ Invoice generated for ${month}`);
  };

  const handleConfigureRates = () => {
    setShowRateConfigModal(true);
  };

  const handleSaveRateConfig = (rateData) => {
    console.log('Saving rate config:', rateData);
    // TODO: Implement actual save with Supabase
    alert('✅ Fee rates configured successfully!');
    setShowRateConfigModal(false);
  };

  const handleExportFees = (format) => {
    alert(`✅ Exporting fees as ${format}...`);
  };

  const handleReconcile = (month) => {
    console.log('Reconciling:', month);
    alert(`✅ Reconciliation started for ${month}`);
  };

  return (
    <div className="flex flex-col h-screen bg-background">
      <TopNavbar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header Section - positioned below TopNavbar */}
        <div className="sticky top-0 z-40 bg-white border-b border-slate-200 shadow-sm mt-[65px]">
          <div className="px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                  <Icon name="DollarSign" size={24} color="#3B82F6" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-slate-900">
                    Fee Register
                  </h1>
                  <p className="text-sm text-slate-600">
                    Automated fee calculation and reconciliation system
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="hidden md:flex items-center gap-2 px-4 py-2 bg-slate-100 rounded-lg">
                  <Icon name="User" size={16} color="#64748B" />
                  <span className="text-sm font-medium text-slate-700">
                    {userRole}
                  </span>
                </div>
                <Button
                  variant="outline"
                  iconName="Download"
                  onClick={handleExport}
                >
                  Export
                </Button>
                {(userRole === 'Finance' || userRole === 'Admin') && (
                  <Button
                    variant="default"
                    iconName="Send"
                    onClick={handleBulkInvoice}
                  >
                    Bulk Invoice
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              <div className="lg:col-span-3">
                <FilterPanel
                  onFilterChange={handleFilterChange}
                  onRateConfig={() => setIsRateConfigOpen(true)}
                />
              </div>

              <div className="lg:col-span-6">
                <div className="space-y-4">
                  <div className="bg-white rounded-lg border border-slate-200 p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <Icon name="Calendar" size={20} color="#3B82F6" />
                        <h2 className="text-lg font-semibold text-slate-900">
                          Monthly Fee Records
                        </h2>
                      </div>
                      <div className="flex items-center gap-2">
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => console.log('Previous month')}
                        >
                          <Icon name="ChevronLeft" size={20} />
                        </Button>
                        <span className="text-sm font-medium text-slate-700 px-3">
                          {filters?.year}
                        </span>
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => console.log('Next month')}
                        >
                          <Icon name="ChevronRight" size={20} />
                        </Button>
                      </div>
                    </div>
                  </div>

                  {feeRecords?.map((record) => (
                    <MonthlyFeeCard
                      key={record?.id}
                      feeData={record}
                      onEdit={handleEditFee}
                      onViewDetails={handleViewDetails}
                      userRole={userRole}
                    />
                  ))}
                </div>
              </div>

              <div className="lg:col-span-3">
                <SummaryPanel summaryData={summaryData} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <FeeRateConfigModal
        isOpen={isRateConfigOpen}
        onClose={() => setIsRateConfigOpen(false)}
        onSave={handleRateConfigSave}
        currentRates={currentRates}
      />

      <FeeDetailsModal
        isOpen={isDetailsModalOpen}
        onClose={() => setIsDetailsModalOpen(false)}
        feeData={selectedFeeData}
      />

      <BulkInvoiceModal
        isOpen={isBulkInvoiceOpen}
        onClose={() => setIsBulkInvoiceOpen(false)}
        feeRecords={feeRecords}
      />
    </div>
  );
};

export default FeeRegister;